import { render, staticRenderFns } from "./MenuItemDetail.vue?vue&type=template&id=2c2af5fa&"
import script from "./MenuItemDetail.vue?vue&type=script&lang=js&"
export * from "./MenuItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports